
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-search-hero{
  display:grid;
  grid-template-rows:1fr 1rem auto;
  background-color:var(--brand-primary-1);
}

  @media screen and (min-width: 425px){.se-search-hero{
    grid-template-rows:1fr 2rem auto
}
  }

  @media screen and (min-width: 768px){.se-search-hero{
    grid-template-rows:minmax(3rem, 1fr) auto 3rem auto
}
  }

.se-search-hero--image,
.se-search-hero--image *{
  width:100%;
}

.se-search-hero--image{
  display:flex;
  grid-area:1 / 1 / 3 / 2;
}

div[cloned-slot-name='image']{
  height:100%;
  width:100%;
  display:flex;
}

div[cloned-slot-name='image'] picture img{
    width:100%;
    object-fit:cover;
    aspect-ratio:16 / 9;
    display:flex;
  }

.se-search-hero--card{
  background-color:var(--brand-neutral-white);
  color:var(--brand-primary-1);
  padding:1.5rem;
  z-index:1;
  width:100%;
}

@media (min-width: 768px){

.se-search-hero--card{
    padding:2rem;
    width:50%
}
  }

.se-search-hero--description{
  font-size:var(--fs-base);
}

se-container{
  grid-area:2 / 1 / 4 / 2;
  display:flex;
  width:100%;
}

@media (min-width: 768px){
  div[cloned-slot-name='image'] picture img{
    aspect-ratio:2.45 / 1;
  }
}
`;